export default function toArray(collection) {
    return [].slice.call(collection);
}
//# sourceMappingURL=toArray.js.map